import React, { useState } from 'react';
import axios from 'axios';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { Alert } from 'react-bootstrap';

function InvitationJoueur(props) {
    const [nom, setNom] = useState('');
    const [prenom, setPrenom] = useState('');
    const [email, setEmail] = useState('');
    const [equipe, setEquipe] = useState();
    const [response, setResponse] = useState(null);
    const [error, setError] = useState(null);
    const [submitted, setSubmitted] = useState(false); 
    const [isLoading, setIsLoading] = useState(false); 
    const [changement, setChangement] = useState(false);

    const apiUrl = process.env.REACT_APP_API_URL;



    const handleSubmit = async (e) => {
        e.preventDefault();
        setChangement(false)
        setIsLoading(true); 
        setError(null)
        setEquipe(props.userData.user.donnée.results[0].id_equipe)
    
        if (!nom || !email || !prenom ) {
          setError("Veuillez remplir tous les champs du formulaire.");
          setIsLoading(false);
          return;
        }

        try {
            const response = await axios.post(`${apiUrl}/inscription/invitation-joueurs`, {
              nom : nom,
              mail: email,
              prenom : prenom,
              id_equipe: equipe,
            }, {
              withCredentials: true 
            });
            setResponse(response.data);
            setError(null);
            setSubmitted(true);
            setIsLoading(false);
            setNom(''); 
            setPrenom('');
            setEmail('');  
          } 
          catch (error) {
            setResponse(null);
            setSubmitted(false);
            setIsLoading(false);
            if (error.response) {
            
              setError(error.response.data.message);
            } else {
           
              setError(true)
            }
          }
        };




  return (
    <>
        {isLoading && (
    <>
              
                    <div className="centered-content">
                        <img src="/img/logo.png" alt="Logo" className="centered-logo" />
                        <br />
                        <span className="loader"></span>
                    </div>
    </>

  )}
        {changement && (
        <Modal show={changement} onHide={() => setChangement(false)}>
          <Modal.Header closeButton>
            <Modal.Title>Invitation d'un joueur</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <>Êtes-vous sûr d'inviter ce joueur ?</>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setChangement(false)}>
              Annuler
            </Button>
            <Button variant="primary" onClick={(e) => {handleSubmit(e)}} style={{backgroundColor:"#00E676", borderColor:'#00E676'}}>
              Inviter
            </Button>
          </Modal.Footer>
        </Modal>
      )}
      {props.userData && (
        <>
        <h2>Inviter un joueur à rejoindre l'équipe</h2>
        {submitted && 
              <>
              <Alert key="success" variant="success" style={{fontSize:"15px", margin:"auto", width : "80%"}}>
                Felicitation ! Votre invitation a été envoyée avec succès à {response.user.name} {response.user.prenom}.
            </Alert>
         </>
        }
        {error && 
              <Alert key="danger" variant="danger" style={{fontSize:"15px", margin:"auto", width : "80%"}}>
                  Erreur ! {error}
              </Alert>
        }
          <div className="card-body">
            <div className="ajout">

        <form className="Invite_Joueur" onSubmit={(e) => {e.preventDefault();setChangement(true)}}> 
          <div>
            <label htmlFor="nom" className="label-1" >
              <br />Nom<br />
              <input
                placeholder="nom"
                name="nom"
                type="text"
                id="nom"
                value={nom}  onChange={(e) => setNom(e.target.value)}
              />
            </label>
          </div>
          <div>
            <label htmlFor="Prenom" className="label-1">
              <br />Prénom<br />
              <input
                placeholder="prenom"
                name="prenom"
                type="text"
                id="prenom"
                value={prenom} onChange={(e) => setPrenom(e.target.value)}
              />
            </label>
          </div>
          <div>
            <label htmlFor="email" className="label-1">
              <br />Email<br />
              <input
                placeholder="nom.prenom@gmail.com"
                name="mail"
                type="text"
                id="Email"
                value={email} onChange={(e) => setEmail(e.target.value)}
              />
            </label>
          </div>
          <br></br>
            <button type="submit" style={{margin:"auto"}} className="conect">
              Envoyer l'invitation
            </button>
          </form>

            </div>
          </div>
        </>)}
        
      
    </>
    
  );
}

export default InvitationJoueur;
